import React, { useState, useEffect, ChangeEvent } from 'react';
import i18n from '../../../translate/i18n';
import GoogleMapReact from "google-map-react";

import TextareaEditor from '../../Form/TextareaEditor';
import Radio from '../../Form/Radio';
import Select from '../../Form/Select';
import Input from '../../Form/Input';

import { RelatoOrgaos } from '../../../services/Report';
import { getNearby } from '../../../services/LocationService';
import ModalStatic from '../../ModalStatic';
import UploadFiles from 'components/Form/UploadFiles';

interface TypeProps {
  data: any,
  handleSelectChange: Function,
  handleInputChange: Function,
  setData: Function,
}

// Marcador do mapa
const MarkerComponent = ({ name, lat, lng }: any) => {
  return <div className={'marker'}>{name}</div>
}

export default function Orgaos({ data, handleSelectChange, handleInputChange, setData }: TypeProps) {

  const [relato, setRelato] = useState('')
  const [searchOrgao, setSearchOrgao] = useState<string>('')
  const [places, setPlaces] = useState<any[]>([])
  const [currentLat, setCurrentLat] = useState<number>(-23.8863672);
  const [currentLong, setCurrentLong] = useState<number>(-46.9771151);

  useEffect(() => {
    async function setInitialData() {
      if (data?.relatoOrgaos)
        await setRelato(data?.relatoOrgaos)
    }
    setInitialData();

    //localização atual do usuario logado
    navigator.geolocation.getCurrentPosition(function (position) {
      const { latitude, longitude } = position.coords;
      setCurrentLat(latitude)
      setCurrentLong(longitude)
    })
  }, [])


  // atualiza relato automatico
  const relatoAutomatico = (event: any) => {
    event.preventDefault();
    RelatoOrgaos(data).then(res => {
      setRelato(res);
    })
  }

  //busca locais proximos
  const getOrgaosProximos = () => {
    if (searchOrgao) {
      getNearby(`${data?.location.geometry.location.lat},${data?.location.geometry.location.lng}`, searchOrgao).then((res: any) => {
        setPlaces(res.data)
      })
    }
  }

  useEffect(() => {
    setData({ ...data, 'relatoOrgaos': relato })
  }, [relato])

  return (
    <div className='container-box'>
      <h5>{i18n.t<string>('edit.public agencies')}</h5>
      <hr />
      <ModalStatic
        title='Pesquisar Orgãos Públicos próximo ao local'
        textButton='Pesquisar Locais'
      >
        <>
          <Select
            title="Pesquisar por:"
            data={[
              { _id: 'hospital', name: 'Hospital' },
              { _id: 'police', name: 'Polícia' },
              { _id: 'fire_station', name: 'Corpo de Bombeiros' },
              { _id: 'car_dealer', name: 'Vendedor de carros' },
              { _id: 'car_rental', name: 'Aluguel de carros' },
              { _id: 'car_repair', name: 'Reparo do carro' },
            ]}
            value={searchOrgao}
            setSelected={(res: any) => { setSearchOrgao(res) }}
          />
          <button className='btn btn-secundary' onClick={getOrgaosProximos}>Buscar</button>
          {places.length > 0 &&
            <div id='map'>
              <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.REACT_APP_API_GOOGLE || '' }}
                defaultCenter={{
                  lat: currentLat,
                  lng: currentLong,
                }}
                defaultZoom={14}
              >
                {places.map((i, index) =>
                  <MarkerComponent
                    key={index}
                    name={i.location?.name || null}
                    lat={i.location?.lat || null}
                    lng={i.location?.lng || null}
                  />
                )}
              </GoogleMapReact>
            </div>
          }
        </>
      </ModalStatic>

      <form >
        <Select
          title="Departamento de Polícia"
          data={[
            { _id: 'militar', name: 'Militar' },
            { _id: 'civil', name: 'Civil' },
            { _id: 'gcm', name: 'GCM' },
            { _id: 'rodoviaria', name: 'Rodoviária' },
            { _id: 'copom', name: 'COPOM' },
          ]}
          value={data?.dptoPolicia || ''}
          setSelected={(value: string) => { handleSelectChange('dptoPolicia', value) }}
        />

        <Radio
          title="Ocorrência"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.ocorrencia || ''}
          setSelected={(value: string) => { handleSelectChange('ocorrencia', value) }}
        />
        {data?.ocorrencia === 'sim' && (

          <Input
            name="numeroOcorrencia"
            label="Número Ocorrência"
            type="text"
            placeholder={'Número Ocorrência'}
            data={data?.numeroOcorrencia || ''}
            setData={handleInputChange}
          />
        )}
        <Radio
          title="Corpo de Bombeiros"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.bombeiros || ''}
          setSelected={(value: string) => { handleSelectChange('bombeiros', value) }}
        />
        <Radio
          title="Concessionária"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.concessionaria || ''}
          setSelected={(value: string) => { handleSelectChange('concessionaria', value) }}
        />
        <Radio
          title="Hospital"
          data={[
            { _id: 'publico', name: 'Público' },
            { _id: 'privado', name: 'Privado' },
            { _id: 'na', name: 'N/A' },
          ]}
          value={data?.hospital || ''}
          setSelected={(value: string) => { handleSelectChange('hospital', value) }}
        />
        <Radio
          title="IML"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.iml || ''}
          setSelected={(value: string) => { handleSelectChange('iml', value) }}
        />
        <button onClick={(event: any) => relatoAutomatico(event)} className='btn btn-secundary w-100'>Relato padrão</button>
        <TextareaEditor
          name="relatoOrgaos"
          label="Relato"
          placeholder={'Relato'}
          data={relato || ''}
          setData={(value: string) => { setRelato(value) }}
        />
        {
          data.id &&
          <UploadFiles
            name="images"
            label="Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF"
            osId={data.id}
            etapa={'orgaos-publicos'}
          />
        }
      </form>
    </div>
  )
}
